import { Component, Inject, Injector } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UploadLayerDialogComponent } from "./upload-layer-dialog.component";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";

@Component({
  selector: "lib-upload-layer-dialog",
  templateUrl: "./phoenix-upload-layer-dialog.component.html",
  styleUrls: ["./upload-layer-dialog.component.scss"],
  standalone: false,
})
export class PhoenixUploadLayerDialogComponent extends UploadLayerDialogComponent {
  layers: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    public injector: Injector,
  ) {
    super(data, injector);
  }
}
